import React, { useState, useEffect } from 'react'
import { Card, CardBody } from 'reactstrap'

import ListTopBar from '../../components/ListTopBar'

import NewFaqModal from './partials/NewFaqModal'
import FaqsTable from './partials/FaqsTable'

import { handleError, parsePagination } from '../../helpers'
import { getFaqs } from './services'

export default function FaqsList() {
	const [faqs, setFaqs] = useState(null)
	const [filterType, setFilterType] = useState('question')
	const [filterValue, setFilterValue] = useState('')
	const [pagination, setPagination] = useState({page: 1, per_page: 15, total: 0})
	const [showNewModal, setShowNewModal] = useState(false)

	useEffect(() => {
		!faqs && getFaqs({
			...pagination,
			[`filter[${filterType}]`]: filterValue,
			include: 'categories,opensCount,departments',
			sort: '-created_at',
		})
			.then(res => {
				setFaqs(res.data.data)
				setPagination(parsePagination(res))
			})
			.catch(error => handleError(error))
	}, [ faqs, pagination, filterType, filterValue ])

	return (
		<React.Fragment>
			<ListTopBar 
				title="Preguntas Frecuentes"
				subtitle="Listado de todas las preguntas frecuentes"
				filterType={filterType}
				setFilterType={setFilterType}
				filterValue={filterValue}
				setFilterValue={setFilterValue}
				reload={() => setFaqs(null)}
				options={[
					{ label: 'Buscar por pregunta', value: 'question' },
					{ label: 'Buscar por respuesta', value: 'answer' },
					{ label: 'Buscar por keywords', value: 'keywords' },
				]}
				ctaText="Agregar Pregunta"
				handleCtaClick={() => setShowNewModal(true)}
			/>
			<Card>
				<CardBody>
					<FaqsTable 
						faqs={faqs}
						reload={() => setFaqs(null)}
						pagination={pagination}
						setPagination={setPagination}
					/>
				</CardBody>
			</Card>
			{ showNewModal && (
				<NewFaqModal 
					visible
					onClose={() => setShowNewModal(false)}
					reload={() => {
						setFaqs(null)
						setShowNewModal(false)
					}}
				/>
			)}
		</React.Fragment>
	)
}